import styles from "./styles.module.scss";
import secondaryComponents from "../..";
import { getPlatform } from "../../../../helpers";
import { useContext, useState } from "react";
import { platformHandler } from "../../../../hooks/context";
import primaryComponents from "../../../primaryComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  BulkRestockIcon,
  ExportIcon,
  PlusIcon,
  ReconciliationIcon,
  RemoveIcon,
  ReturnIcon,
  TransferIcon,
} from "../../../../assets/svgIcons";
import { pathConstants } from "../../../../routes/pathContants";
import { RoutedModal } from "../../../common";
import { RestockFlowPrompt } from "../../Restocks";

export const ProductQuickActions = ({ is_composite = false }) => {
  const [search] = useSearchParams();
  const { platform } = useContext(platformHandler);
  const navigate = useNavigate();
  const [views, setViews] = useState({
    isProductWidget: false,
    isRemoveStock: search.get("sidemodal") === "removestock" ? true : false,
    isExport: search.get("sidemodal") === "export" ? true : false,
    isRestock: false,
  });

  const closeView = (key) => {
    setViews((prev) => ({ ...prev, [key]: false }));
  };
  return (
    <>
      <div className={styles.headerLeft}>
        {getPlatform(platform) === "/app" ? (
          <>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_export_product"
            >
              <secondaryComponents.ToolTipV2 tipText="Export Inventory">
                <primaryComponents.Button
                  classNames="btn btn--outline-yellow"
                  onClick={() =>
                    setViews((prev) => ({ ...prev, isExport: true }))
                  }
                  style={{ width: "60px" }}
                >
                  <ExportIcon />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_transfer_product"
            >
              <secondaryComponents.ToolTipV2 tipText="Transfer Stock">
                <primaryComponents.Button
                  classNames="btn btn--outline-green"
                  onClick={() =>
                    navigate(
                      pathConstants.INVENTORY_PRODUCT_BULK_TRANSFER_HISTORY,
                    )
                  }
                  style={{ width: "60px" }}
                >
                  <TransferIcon />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_remove_products"
            >
              <secondaryComponents.ToolTipV2 tipText="Remove Stock">
                <primaryComponents.Button
                  classNames="btn btn--outline-red"
                  onClick={() =>
                    setViews((prev) => ({ ...prev, isRemoveStock: true }))
                  }
                  style={{ width: "60px" }}
                >
                  <RemoveIcon />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_create_and_submit_reconciliation"
            >
              <primaryComponents.Button
                classNames="btn btn--yellow"
                onClick={() =>
                  navigate(pathConstants.INVENTORY_RECONCILIATIONS({}))
                }
              >
                <ReconciliationIcon />
                <span className="ml-2">Reconciliation</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_view_returns"
            >
              <primaryComponents.Button
                classNames="btn btn--orange"
                onClick={() => navigate(pathConstants.INVENTORY_RETURNS)}
              >
                <ReturnIcon />
                <span className="ml-2">Returns</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_restock_products_bulk_and_single_restock"
            >
              <primaryComponents.Button
                classNames="btn btn--success"
                onClick={() =>
                  setViews((prev) => ({ ...prev, isRestock: true }))
                }
              >
                <BulkRestockIcon />
                <span className="ml-2">Restock</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </>
        ) : null}

        <secondaryComponents.NavigateWithPermission
          permissionParentKey={"Inventory Management"}
          permissionChildKey="can_add_products"
        >
          {is_composite ? (
            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() =>
                navigate(pathConstants.INVENTORY_PRODUCTS_ADD_COMPOSITE)
              }
            >
              <PlusIcon className="mr-1" /> Create Composite
            </primaryComponents.Button>
          ) : (
            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() =>
                setViews((prev) => ({ ...prev, isProductWidget: true }))
              }
            >
              <PlusIcon className="mr-1" /> Create Product
            </primaryComponents.Button>
          )}
        </secondaryComponents.NavigateWithPermission>
      </div>

      {/* product widget */}
      <secondaryComponents.Modal
        isActive={views?.isProductWidget}
        closeModal={() => closeView("isProductWidget")}
        width={"800px"}
      >
        <secondaryComponents.AddProductWidget
          closeModal={() => closeView("isProductWidget")}
        />
      </secondaryComponents.Modal>

      {/* delete stock sidebar */}
      <secondaryComponents.SideModal
        width={650}
        isActive={views?.isRemoveStock}
        closeModal={() => closeView("isRemoveStock")}
      >
        <secondaryComponents.DeleteStockWidget
          closeWidget={() => closeView("isRemoveStock")}
        />
      </secondaryComponents.SideModal>

      {/* export products sidebar */}
      <secondaryComponents.SideModal
        isActive={views?.isExport}
        closeModal={() => closeView("isExport")}
      >
        <secondaryComponents.ProductsExport
          closeWidget={() => closeView("isExport")}
        />
      </secondaryComponents.SideModal>

      <RoutedModal
        width={650}
        headerTitle="Select Procurement Option"
        isActive={views?.isRestock}
        closeModal={() => closeView("isRestock")}
        style={{ height: "auto" }}
      >
        <RestockFlowPrompt />
      </RoutedModal>
    </>
  );
};
